import React, { useEffect, useState } from 'react';
import { fetchAppointmentDays } from '../adapaters/fetchAppointmentDays';
import { useAtom } from 'jotai';
import { selectedTurnBase } from '../shared/selected.turn.base';
import { selectedTurnItem } from '../shared/selected.turn.items';
import { selectedDoctorAtom } from '../shared/selected.doctor';
import { selectedDepartmentAtom } from '../shared/selected.department';
import { selectedSpecialityServiceAtom } from '../shared/selected.speciality.service';
import { seletedDepartmentId } from '../shared/selected.department.ids';
import moment from 'moment-jalaali';
import { GetCurrentDateInJalai } from 'utils/GetCurrentDateInJalai';

const useCreateDataForDayTimeApi = (range) => {
  const [dayList, setDayList] = useState(null);

  const [turnBase] = useAtom(selectedTurnBase);
  const [selected] = useAtom(selectedTurnItem);
  const [selectedDoctor] = useAtom(selectedDoctorAtom);
  const [selectedDepartment] = useAtom(
    selectedDepartmentAtom
  );
  const [selectedSpecialityService] = useAtom(
    selectedSpecialityServiceAtom
  );
  const [departmentIds] = useAtom(seletedDepartmentId);

  useEffect(() => {
    if (range?.ToDate && range?.ToDate?.length !== 0) {
      const datas = {
        idService:
          turnBase === 'speciality'
            ? selectedSpecialityService?.id
            : selected?.id,
        idSpeciality: 0,
        startDate: moment(
          GetCurrentDateInJalai(),
          'jYYYY/jM/jD'
        ).format('YYYY/MM/DD'),
        endDate: moment(
          range.ToDate,
          'jYYYY/jMM/jDD'
        ).format('YYYY/MM/DD'),
        idPerson: selectedDoctor?.doctor?.id,
        topRecord: 30,
        idDarmangah: selectedDepartment.Id,
        idDepartment: departmentIds
          ? departmentIds[0]?.Id
          : 0,
      };

      // console.log('+++++++++++++++++++>', {
      //   datas,
      //   turnBase,
      //   selected,
      // });

      fetchAppointmentDays(datas, setDayList);
    }
  }, [
    range?.ToDate,
    range?.FromDate,
    selectedDepartment,
    departmentIds,
    selectedDoctor,
    selected,
  ]);

  return dayList;
};

export default useCreateDataForDayTimeApi;
